import React from "react";
import gql from "graphql-tag";
import { constants } from "@services";
import { Box, Flex, Text, Circle } from "@atoms";
import { FundsPageEarningsLegendFragment } from "./__generated__/FundsPageEarningsLegendFragment";

// == Types ================================================================

interface IProps {
  campaign: FundsPageEarningsLegendFragment;
}

// == Constants ============================================================

FundsPageEarningsLegend.fragments = gql`
  fragment FundsPageEarningsLegendFragment on Campaign {
    id
    amountRaisedBreakdown {
      shopping {
        formatted
      }
      donations {
        formatted
      }
      bonuses {
        formatted
      }
    }
  }
`;

// == Component ============================================================

export default function FundsPageEarningsLegend({ campaign }: IProps) {
  const {
    amountRaisedBreakdown: { bonuses, shopping, donations },
  } = campaign;
  const [colorShopping, colorDonations, colorBonuses] = constants.CHART_COLORS;

  return (
    <Box bg="lightBlueBg" height="100%" paddingRight={[1, 1, 2]}>
      <Flex alignItems="flex-start" flexDirection="column" justifyContent="space-between">
        <Flex alignItems="center" padding={[2, 2, 3]}>
          <Circle bg={colorShopping} height={10} width={10} />
          <Flex flexDirection="column" paddingLeft={2}>
            <Box>
              <Text fontSize={[1, 2, 3]}>{shopping.formatted}</Text>
            </Box>
            <Box>
              <Text fontSize={[0, 1, 2]}>Shopping</Text>
            </Box>
          </Flex>
        </Flex>
        <Flex alignItems="center" padding={[2, 2, 3]}>
          <Circle bg={colorDonations} height={10} width={10} />
          <Flex flexDirection="column" paddingLeft={2}>
            <Box>
              <Text fontSize={[1, 2, 3]}>{donations.formatted}</Text>
            </Box>
            <Box>
              <Text fontSize={[0, 1, 2]}>Donations</Text>
            </Box>
          </Flex>
        </Flex>
        <Flex alignItems="center" padding={[2, 2, 3]}>
          <Circle bg={colorBonuses} height={10} width={10} />
          <Flex flexDirection="column" paddingLeft={2}>
            <Box>
              <Text fontSize={[1, 2, 3]}>{bonuses.formatted}</Text>
            </Box>
            <Box>
              <Text fontSize={[0, 1, 2]}>Bonuses</Text>
            </Box>
          </Flex>
        </Flex>
      </Flex>
    </Box>
  );
}

// == Styles ===============================================================
